import CloseIcon from "@mui/icons-material/Close";
import Button from "../editor/toolbar/Button";
import { GappedAndFilledBillet, LicensedJobType, LicensedJobTypeLabel, UnLicensedJobType, UnLicensedJobTypeLabel } from '../../common/JobOrder'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import { exportSingleSheetExcel } from '../../util/excelDocument';

const getJobTypeLabel = (value: string) => {
  const unlicensed = value as UnLicensedJobType;
  
  if (Object.values(UnLicensedJobType).includes(unlicensed)) {
    return UnLicensedJobTypeLabel[unlicensed];
  } else {
    return LicensedJobTypeLabel[value as LicensedJobType];
  }
}

const GappedAndFilledBillets = (props: {
  gappedAndFilledBillets: GappedAndFilledBillet[];
  onClose: () => void;
}) => {
const exportFile = async () => {
  await exportSingleSheetExcel({
    data: props.gappedAndFilledBillets,
    documentName: 'GappedAndFilledBillets',
    sheetName: 'Billets'
  }, [
    {
      label: "Fleet",
      name: "fleetName",
      width: 10,
    },
    {
      label: "Vessel",
      name: "vesselName",
      width: 20,
    },
    {
      label: "Specialist",
      name: "assigneeId",
      width: 20,
    },
    {
      label: "Billet Type",
      name: "billetType",
      width: 15,
      custom: (row: any) => getJobTypeLabel(row.jobType),
    },
    {
      label: "Billet",
      name: "billet",
      width: 10,
      custom: (row: any) => row.rating.toString().substring(1),
    },
    {
      label: "Opened Date",
      name: "dateOpen",
      width: 15,
      custom: (row: any) => moment(row.createdDate).format("MM/DD/YYYY"),
    },
    {
      label: "Filled Date",
      name: "dateFilled",
      width: 15,
      custom: (row: any) => row.billetStatus === 'GAPPED' ? '' : moment(row.completedDate).format("MM/DD/YYYY"),
    },
    {
      label: "Departure Date",
      name: "departureDate",
      width: 15,
      custom: (row: any) => row.departedDate ? moment(row.departedDate).format("MM/DD/YYYY") : '',
    },
    {
      label: "Report Date",
      name: "fillByDate",
      width: 15,
      custom: (row: any) => moment(row.fillByDate).format("MM/DD/YYYY"),
    },
    {
      label: "Status",
      name: "status",
      width: 10,
      custom: (row: any) => row.billetStatus[0] + row.billetStatus.slice(1).toLowerCase()
    },
    {
      label: "Days Gapped",
      name: "daysGapped",
      width: 15,
    },
  ]);
};

  return (
    <div>
      <div className="flex align-items-center justify-content-btwn mb-1">
        <h1 className="mr-2">Gapped and Filled Billets</h1>
        <div className="flex g-1">
        <Button onClick={exportFile}>
          EXPORT TO EXCEL
        </Button>
        <Button onClick={props.onClose}>
          <CloseIcon />
        </Button>
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><b>Fleet</b></TableCell>
            <TableCell><b>Vessel</b></TableCell>
            <TableCell><b>Specialist</b></TableCell>
            <TableCell><b>Billet Type</b></TableCell>
            <TableCell><b>Billet</b></TableCell>
            <TableCell><b>Opened Date</b></TableCell>
            <TableCell><b>Filled Date</b></TableCell>
            <TableCell><b>Departure Date</b></TableCell>
            <TableCell><b>Report Date</b></TableCell>
            <TableCell><b>Status</b></TableCell>
            <TableCell><b>Days Gapped</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.gappedAndFilledBillets.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.fleetName}</TableCell>
              <TableCell>{row.vesselName}</TableCell>
              <TableCell>{row.assigneeId}</TableCell>
              <TableCell>{getJobTypeLabel(row.jobType)}</TableCell>
              <TableCell>{row.rating.toString().substring(1)}</TableCell>
              <TableCell>{moment(row.createdDate).format("MM/DD/YYYY")}</TableCell>
              <TableCell>{row.billetStatus === 'GAPPED' ? '' : moment(row.completedDate).format("MM/DD/YYYY")}</TableCell>
              <TableCell>{row.departedDate ? moment(row.departedDate).format("MM/DD/YYYY") : ''}</TableCell>
              <TableCell>{moment(row.fillByDate).format("MM/DD/YYYY")}</TableCell>
              <TableCell>{row.billetStatus[0] + row.billetStatus.slice(1).toLowerCase()}</TableCell>
              <TableCell>{row.daysGapped}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default GappedAndFilledBillets;
